"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconSearch', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M11.0317 9.61752L14.7071 13.2929C15.0976 13.6834 15.0976 14.3166 14.7071 14.7071C14.3166 15.0976 13.6834 15.0976 13.2929 14.7071L9.61753 11.0317C8.73148 11.6424 7.6575 12 6.5 12C3.46243 12 1 9.53757 1 6.5C1 3.46243 3.46243 0.999999 6.5 1C9.53757 1 12 3.46243 12 6.5C12 7.6575 11.6424 8.73148 11.0317 9.61752ZM3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M13.6004 12.2001C13.6376 12.2281 13.6733 12.259 13.7071 12.2929L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12.2929 13.7071C12.259 13.6733 12.2281 13.6376 12.2001 13.6004C11.0302 14.4792 9.57591 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 9.57592 14.4792 11.0302 13.6004 12.2001ZM3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M16.1759 14.7618L22.707 21.2929C23.0975 21.6834 23.0975 22.3166 22.707 22.7071C22.3165 23.0976 21.6833 23.0976 21.2928 22.7071L14.7617 16.176C13.3144 17.3183 11.4867 18 9.49988 18C4.80546 18 0.999876 14.1944 0.999878 9.5C0.999878 4.80558 4.80546 1 9.49988 1C14.1943 1 17.9999 4.80558 17.9999 9.5C17.9999 11.4869 17.3182 13.3145 16.1759 14.7618ZM2.99988 9.5C2.99988 5.91015 5.91003 3 9.49988 3C13.0897 3 15.9999 5.91015 15.9999 9.5C15.9999 13.0899 13.0897 16 9.49988 16C5.91003 16 2.99988 13.0899 2.99988 9.5Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M21.7667 19.6453L30.0608 27.9393C30.6466 28.5251 30.6466 29.4749 30.0608 30.0607C29.475 30.6464 28.5252 30.6464 27.9395 30.0607L19.6454 21.7666C17.7993 23.1682 15.4968 24 13.0001 24C6.92499 24 2.00012 19.0751 2.00012 13C2.00012 6.92487 6.92499 2 13.0001 2C19.0753 2 24.0001 6.92487 24.0001 13C24.0001 15.4967 23.1683 17.7991 21.7667 19.6453ZM21.0001 13C21.0001 17.4183 17.4184 21 13.0001 21C8.58185 21 5.00012 17.4183 5.00012 13C5.00012 8.58172 8.58185 5 13.0001 5C17.4184 5 21.0001 8.58172 21.0001 13Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;